const dirty = new Set<string>();

export function setUnsavedChanges(key: string, isDirty: boolean): void {
  if (isDirty) dirty.add(key);
  else dirty.delete(key);
}

export function hasUnsavedChanges(): boolean {
  return dirty.size > 0;
}
